import * as React from 'react';
import { cn } from '@/lib/utils';

const GuideAboutSection = React.forwardRef(({ className, ...props }, ref) => (
  <section
    ref={ref}
    className={cn('c-guide-about-section', 'z-10 flex flex-col gap-10', className)}
    {...props}
  />
));
GuideAboutSection.displayName = 'GuideAboutSection';

const GuideAboutSectionHeader = React.forwardRef(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn('c-guide-about-section-header', 'flex w-[728px] max-w-full flex-wrap items-center gap-8 px-8 py-4', className)}
    {...props}
  />
));
GuideAboutSectionHeader.displayName = 'GuideAboutSectionHeader';

const GuideAboutSectionImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('c-guide-about-section-img', 'w-32 shrink-0', className)}
    {...props}
  />
));
GuideAboutSectionImg.displayName = 'GuideAboutSectionImg';

const GuideAboutSectionTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn('c-guide-about-section-title', 'w-[200px] max-w-full grow text-lg font-bold leading-tight text-primary-dark', className)}
    {...props}
  />
));
GuideAboutSectionTitle.displayName = 'GuideAboutSectionTitle';

const GuideAboutSectionBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about-section-body', 'flex flex-wrap items-start gap-10', className)}
    {...props}
  />
));
GuideAboutSectionBody.displayName = 'GuideAboutSectionBody';

const GuideAboutSectionDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-guide-about-section-description', 'mb-0 w-[200px] max-w-full bg-white px-0 py-5 text-base font-light text-neutral-darker', className)}
    {...props}
  />
));
GuideAboutSectionDescription.displayName = 'GuideAboutSectionDescription';

const GuideAboutSectionList = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about-section-list', 'flex grow flex-wrap gap-5', className)}
    {...props}
  />
));
GuideAboutSectionList.displayName = 'GuideAboutSectionList';

export { GuideAboutSection, GuideAboutSectionHeader, GuideAboutSectionImg, GuideAboutSectionTitle, GuideAboutSectionBody, GuideAboutSectionDescription, GuideAboutSectionList };
